import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { setSkipEmailUserDetails } from 'state/booking/actions'
import { removeSkipEmailAccessToken } from '../utils'
import { pageRoutes } from 'constants/routing'

const BookingsLayout = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const router = useRouter()
  const dispatch = useDispatch()

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (!url.includes(pageRoutes.BOOKING)) {
        removeSkipEmailAccessToken()
        dispatch(setSkipEmailUserDetails(undefined))
      }
    }

    router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router])

  return <>{children}</>
}

export default BookingsLayout
